import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';

const Footer = React.memo(() => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  
  return (
    <Box
      component="footer"
      sx={{
        height: '48px',
        width: '100%',
        maxWidth: '1920px',
        backgroundColor: isDark ? '#192033' : theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: `1px solid ${theme.palette.divider}`,
        px: 3,
        mx: 'auto'
      }}
    >
      {/* Left side - Copyright */}
      <Typography 
        variant="body2" 
        sx={{ 
          color: theme.palette.text.primary,

        }}
      >
        © Unilever 2026
      </Typography>

      {/* Right side - Links */}
      <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
        <Link
          href="#"
          underline="always"
          sx={{
            color: theme.palette.text.primary,
            fontSize: '14px',
            textDecorationColor: theme.palette.text.primary,
            '&:hover': {
              color: theme.palette.text.secondary
            }
          }}
        >
          Privacy policy
        </Link>
        <Link
          href="#"
          underline="always"
          sx={{
            color: theme.palette.text.primary,
           fontSize: '14px',
            textDecorationColor: theme.palette.text.primary,
            '&:hover': {
              color: theme.palette.text.secondary
            }
          }}
        >
          Cookie policy
        </Link>
        <Link
          href="#"
          underline="always"
          sx={{
            color: theme.palette.text.primary,
            fontSize: '14px',
            textDecorationColor: theme.palette.text.primary,
            '&:hover': {
              color: theme.palette.text.secondary
            }
          }}
        >
          Terms of use
        </Link>
      </Box>
    </Box>
  );
});

export default Footer;